<ng-container *ngIf="resumeloading == false">
  <div class="container text-center">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </div>
</ng-container>
<ng-container *ngIf="resumeloading">
  <div class="row">
    <div class="col-lg-3">
      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS FINANCIEROS</th>
        </tr>
        <tr>
          <td colspan="2">1- RENTABILIDAD ECONOMICA…ROA</td>
        </tr>
        <tr>
          <td>RESULTADO DE EXPLOTACION</td>
          <td></td>
        </tr>
        <tr>
          <td>ACTIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>ROA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * para categorizar a la empresa como rentable el ROA debe ser superior al 5%
          </td>
        </tr>

        <tr>
          <td colspan="2">2- TASA RETORNO INVERSION...ROI</td>
        </tr>
        <tr>
          <td>INGRESOS</td>
          <td></td>
        </tr>
        <tr>
          <td>INVERSION</td>
          <td></td>
        </tr>
        <tr>
          <td>ROI</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * a mayor importe mejor inversión,pero a partir del 10%, es aceptable
          </td>
        </tr>

        <tr>
          <td colspan="2">3- RENTABILIDAD FINANCIERA…ROE</td>
        </tr>
        <tr>
          <td>RESULTADO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>FONDOS PROPIOS</td>
          <td></td>
        </tr>
        <tr>
          <td>ROE</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * se considera bueno entre un 15-20%
          </td>
        </tr>

        <tr>
          <td colspan="2">4- RETORNO SOBRE EL CAPITAL EMPLEADO…ROCE</td>
        </tr>
        <tr>
          <td>RESULTADO DE EXPLOTACION</td>
          <td></td>
        </tr>
        <tr>
          <td>ACTIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>ROCE</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * Una relación del 10% se consideraría un buen ROCE.
          </td>
        </tr>

      </table>
    </div>
    <div class="col-lg-3">
      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS DE LIQUIDEZ</th>
        </tr>
        <tr>
          <td colspan="2">1- RATIO DE LIQUIDEZ</td>
        </tr>
        <tr>
          <td>ACTIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>LIQUIDEZ</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * entre 1,5-2
          </td>
        </tr>

        <tr>
          <td colspan="2">2- RATIO DE TESORERÍA</td>
        </tr>
        <tr>
          <td>DISPONIBLE</td>
          <td></td>
        </tr>
        <tr>
          <td>REALIZABLE</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>TESORERIA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * siempre cerca del 1
          </td>
        </tr>

        <tr>
          <td colspan="2">3- RATIO DE DISPONIBILIDAD</td>
        </tr>
        <tr>
          <td>DISPONIBLE</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>DISPONIBILIDAD</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *entre 0,1-0,15
          </td>
        </tr>

        <tr>
          <td colspan="2">4- BURN RATE</td>
        </tr>
        <tr>
          <td>DINERO QUE TENGO</td>
          <td></td>
        </tr>
        <tr>
          <td>TOTAL GASTOS MES<br />(incluidos financiaciones) </td>
          <td></td>
        </tr>
        <tr>
          <td>DISPONIBILIDAD</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *este ratio indica en cuantos meses me gastaré el dinero que tengo
          </td>
        </tr>
      </table>


      <!-- ------------------------ -->
      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS DE SOLVENCIA</th>
        </tr>
        <tr>
          <td colspan="2">1- RATIO DE SOLVENCIA</td>
        </tr>
        <tr>
          <td>ACTIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO EXIGIBLE</td>
          <td></td>
        </tr>
        <tr>
          <td>SOLVENCIA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * empresa equilibrada cuando valor cerca de 1,5
          </td>
        </tr>

        <tr>
          <td colspan="2">2- RATIO DE CONSISTENCIA</td>
        </tr>
        <tr>
          <td>ACTIVO NO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO NO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>CONSISTENCIA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * valor optimo igual a 2
          </td>
        </tr>

        <tr>
          <td colspan="2">3- RATIO DE ESTABILIDAD</td>
        </tr>
        <tr>
          <td>ACTIVO NO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PATRIMONIO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO NO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>ESTABILIDAD</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * menos de 1 como valor ideal
          </td>
        </tr>
      </table>

      <!-- ------------------------ -->
      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS SOBRE LA DEUDA</th>
        </tr>
        <tr>
          <td colspan="2">1- RATIO DE ENDEUDAMIENTO</td>
        </tr>
        <tr>
          <td>PASIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>PATRIMONIO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>ENDEUDAMIENTO</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * valor ideal entre 0,4-0,6
          </td>
        </tr>

        <tr>
          <td colspan="2">2- RATIO DE APALANCAMIENTO</td>
        </tr>
        <tr>
          <td>ACTIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>PATRIMONIO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>APALANCAMIENTO</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * > 1 inidca que es rentable recurrir a financiación ajena
          </td>
        </tr>

        <tr>
          <td colspan="2">3- RATIO DE ENDEUDAMIENTO A LP</td>
        </tr>
        <tr>
          <td>PASIVO NO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PATRIMONIO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>ENDEUDAMIENTO LP</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * valor ideal entre 0,4-0,6
          </td>
        </tr>

        <tr>
          <td colspan="2">4- RATIO DE ENDEUDAMIENTO A CP</td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PATRIMONIO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>ENDEUDAMIENTO CP</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * valor ideal entre 0,4-0,6
          </td>
        </tr>

        <tr>
          <td colspan="2">5- PORCENTAJE DEUDA A LP</td>
        </tr>
        <tr>
          <td>PASIVO NO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>DEUDA A LP</td>
          <td></td>
        </tr>

        <tr>
          <td colspan="2">6- PORCENTAJE DEUDA A CP</td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>DEUDA A CP</td>
          <td></td>
        </tr>

        <tr>
          <td colspan="2">7- PORCENTAJE DEUDA FINANCIERA A CP</td>
        </tr>
        <tr>
          <td>GASTOS FINANCIEROS</td>
          <td></td>
        </tr>
        <tr>
          <td>VENTAS</td>
          <td></td>
        </tr>
        <tr>
          <td>GASTOS FINANCIEROS</td>
          <td></td>
        </tr>
      </table>
    </div>
    <div class="col-lg-3">
      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS COMERCIALES</th>
        </tr>
        <tr>
          <td colspan="2">MARKETING</td>
        </tr>
        <tr>
          <td colspan="2"></td>
        </tr>
        <tr>
          <td colspan="2">1- COSTE DE ADQUIRIR CLIENTES…CAD</td>
        </tr>
        <tr>
          <td>GASTOS MARKETING (627.1)</td>
          <td></td>
        </tr>
        <tr>
          <td>Nº CLIENTES ADQUIRIDOS</td>
          <td></td>
        </tr>
        <tr>
          <td>CAC</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *se hace por periodos: se ejectuta una acción comercial y se analizan los clientes captados
          </td>
        </tr>

        <tr>
          <td colspan="2">2-TIEMPO DE RECUPERACIÓN INVERSION MK</td>
        </tr>
        <tr>
          <td>CAC</td>
          <td></td>
        </tr>
        <tr>
          <td>ARPU</td>
          <td></td>
        </tr>
        <tr>
          <td>TR</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *cuanto mas bajo mejor, quiere decir que antes recuperamos la inversión
          </td>
        </tr>

        <tr>
          <td colspan="2">3- COEF. CAPTACION CLIENTES…CRC</td>
        </tr>
        <tr>
          <td>LTV</td>
          <td></td>
        </tr>
        <tr>
          <td>CAC</td>
          <td></td>
        </tr>
        <tr>
          <td>CAPTACION</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *Mide la eficiencia en la captación de clientes
          </td>
        </tr>

        <tr>
          <td colspan="2">4- RATIO DE CONVERSION</td>
        </tr>
        <tr>
          <td>Nº CLIENTES QUE COMPRAN</td>
          <td></td>
        </tr>
        <tr>
          <td>TOTAL PERSONA OBJETIVO</td>
          <td></td>
        </tr>
        <tr>
          <td>RC</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
          </td>
        </tr>

        <tr>
          <td colspan="2">5- RATIO ABANDONO DEL CARRITO…NPS</td>
        </tr>
        <tr>
          <td>COMPRADORES</td>
          <td></td>
        </tr>
        <tr>
          <td>DETRACTORES</td>
          <td></td>
        </tr>
        <tr>
          <td>NPS</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * debe ser lo menor posible
          </td>
        </tr>
      </table>

      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS COMERCIALES</th>
        </tr>
        <tr>
          <td colspan="2">CLIENTES</td>
        </tr>
        <tr>
          <td colspan="2"></td>
        </tr>
        <tr>
          <td colspan="2">1-INGRESOS SEGÚN CLIENTES ACTIVO…ARPU</td>
        </tr>
        <tr>
          <td>TOTAL INGRESOS OBTENIDOS</td>
          <td></td>
        </tr>
        <tr>
          <td>TOTAL CLIENTES ACTIVOS</td>
          <td></td>
        </tr>
        <tr>
          <td>ARPU</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *cuanto mayor sea indica que a cada cliente les estamos vendiendo bien.
          </td>
        </tr>

        <tr>
          <td colspan="2">2- RECURRENCIA</td>
        </tr>
        <tr>
          <td colspan="2">CADA CUANTO NOS COMPRAN LOS CLIENTES</td>
        </tr>
        <tr>
          <td>DÍAS</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * expresado en días
          </td>
        </tr>

        <tr>
          <td colspan="2">3- VALOR DE VIDA DEL CLIENTE…LTV</td>
        </tr>
        <tr>
          <td>MARGEN BRUTO </td>
          <td></td>
        </tr>
        <tr>
          <td>RECURRENCIA</td>
          <td></td>
        </tr>
        <tr>
          <td>LTV</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *cuanto mayor sea mayor valor tiene el cliente
          </td>
        </tr>

        <tr>
          <td colspan="2">4- RATIO PERDIDA DE CLIENTES...CHURM</td>
        </tr>
        <tr>
          <td>CLIENTES PERDIDOS</td>
          <td></td>
        </tr>
        <tr>
          <td>CLIENTES INICIALES</td>
          <td></td>
        </tr>
        <tr>
          <td>LTV</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * debe ser lo menor posible
          </td>
        </tr>

        <tr>
          <td colspan="2">5- RATIO DE SUSCIRPCION… MRR</td>
        </tr>
        <tr>
          <td>ARPU</td>
          <td></td>
        </tr>
        <tr>
          <td>Nº USUARIOS</td>
          <td></td>
        </tr>
        <tr>
          <td>MRR</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * cuanto mayor sea mejor
          </td>
        </tr>
      </table>

      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS COMERCIALES</th>
        </tr>
        <tr>
          <td colspan="2">TIENDAS/FRANQUICIAS/EMPLEADOS</td>
        </tr>
        <tr>
          <td colspan="2"></td>
        </tr>
        <tr>
          <td colspan="2">1-VENTAS POR METRO CUADRADO</td>
        </tr>
        <tr>
          <td>VENTAS TOTALES</td>
          <td></td>
        </tr>
        <tr>
          <td>M2 DEL LOCAL</td>
          <td></td>
        </tr>
        <tr>
          <td>VTA/M2</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
          </td>
        </tr>

        <tr>
          <td colspan="2">2- VENTAS POR EMPLEADO</td>
        </tr>
        <tr>
          <td>VENTAS TOTALES</td>
          <td></td>
        </tr>
        <tr>
          <td>Nº DE EMPLEADOS</td>
          <td></td>
        </tr>
        <tr>
          <td>LTV</td>
          <td></td>
        </tr>


        <tr>
          <td colspan="2">3- PRODUCTIVIDAD DE LA PLANTILLA</td>
        </tr>
        <tr>
          <td>VENTAS TOTALES</td>
          <td></td>
        </tr>
        <tr>
          <td>INGRESOS EXTRAORDINARIOS</td>
          <td></td>
        </tr>
        <tr>
          <td>GASTOS EXPLOTACION</td>
          <td></td>
        </tr>
        <tr>
          <td>GASTOS PERSONAL</td>
          <td></td>
        </tr>
        <tr>
          <td>PRODUCTIVIDAD</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
          </td>
        </tr>

        <tr>
          <td colspan="2">4- ROTACION DEL INVENTARIO</td>
        </tr>
        <tr>
          <td>COSTES PRODUCTOS VENDIDOS</td>
          <td></td>
        </tr>
        <tr>
          <td>VALOR MEDIO DEL INVENTARIO</td>
          <td></td>
        </tr>
        <tr>
          <td>VALOR INVENTARIO A 01/01/XX</td>
          <td></td>
        </tr>
        <tr>
          <td>VALOR INVENTARIO A 31/12/XX</td>
          <td></td>
        </tr>
        <tr>
          <td>ROTACION</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *cuanto mayor sea mas rotación
          </td>
        </tr>
      </table>
    </div>
    <div class="col-lg-3">
      <table class="tabla-resultados">
        <tr>
          <th colspan="2" style="font-weight: bold;">RATIOS PARA INVERSORES</th>
        </tr>
        <tr>
          <td colspan="2">PARA INVERSORES</td>
        </tr>
        <tr>
          <td colspan="2">1- PER: RATIO PRECIO-BENEFICIO</td>
        </tr>
        <tr>
          <td>PRECIO ACCION</td>
          <td></td>
        </tr>
        <tr>
          <td>BENEFICIO NETO POR ACCION</td>
          <td></td>
        </tr>
        <tr>
          <td>PER</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            *Indica el número de años para que el inversor recupere la inversión
          </td>
        </tr>

        <tr>
          <td colspan="2">2-EBITDA</td>
        </tr>
        <tr>
          <td>INGRESOS/VENTAS</td>
          <td></td>
        </tr>
        <tr>
          <td>COMPRAS/CONSUMOS</td>
          <td></td>
        </tr>
        <tr>
          <td>GASTOS PERSONAL</td>
          <td></td>
        </tr>
        <tr>
          <td>OTROS GASTOS EXPLOTACION</td>
          <td></td>
        </tr>
        <tr>
          <td>EBITDA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
          </td>
        </tr>

        <tr>
          <td colspan="2">3-BPA…BENEFICIO POR ACCION</td>
        </tr>
        <tr>
          <td>BENEFICIO NETO</td>
          <td></td>
        </tr>
        <tr>
          <td>Nº DE ACCIONES</td>
          <td></td>
        </tr>
        <tr>
          <td>BPA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * se considera bueno entre un 15-20%
          </td>
        </tr>

        <tr>
          <td colspan="2">4- RETORNO SOBRE EL CAPITAL EMPLEADO…ROCE</td>
        </tr>
        <tr>
          <td>RESULTADO DE EXPLOTACION</td>
          <td></td>
        </tr>
        <tr>
          <td>ACTIVO TOTAL</td>
          <td></td>
        </tr>
        <tr>
          <td>PASIVO CORRIENTE</td>
          <td></td>
        </tr>
        <tr>
          <td>ROCE</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            * Una relación del 10% se consideraría un buen ROCE.
          </td>
        </tr>

      </table>
    </div>
  </div>
</ng-container>